import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";

const inputCls =
    "w-full border border-white/15 bg-white/5 px-4 py-3.5 text-sm text-white placeholder-white/35 outline-none transition-colors duration-300 focus:border-tl-orange";

export const AdminLogin = ({ onSuccess }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            onSuccess(data.user);
        } catch (err) {
            setError(apiError(err, "Accesso non riuscito. Riprova."));
        } finally {
            setLoading(false);
        }
    };

    return (
        <form
            data-testid="admin-login-form"
            onSubmit={submit}
            className="mx-auto w-full max-w-md border border-white/10 bg-tl-dark p-8 sm:p-10"
        >
            <div className="flex items-center gap-3">
                <Lock size={18} className="text-tl-orange" />
                <p className="font-mono-tl text-[11px] uppercase tracking-[0.3em] text-tl-orange">Area riservata</p>
            </div>
            <h1 className="mt-5 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
                Accedi<span className="text-tl-orange">.</span>
            </h1>
            <p className="mt-2 text-sm text-tl-mutedLight">Gestione foto della galleria TECNO-LAV.</p>
            <div className="mt-8 space-y-5">
                <div>
                    <label htmlFor="admin-email" className="mb-2 block text-xs uppercase tracking-[0.15em] text-white/60">Email</label>
                    <input
                        id="admin-email"
                        data-testid="admin-login-email"
                        type="email"
                        required
                        autoComplete="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={inputCls}
                    />
                </div>
                <div>
                    <label htmlFor="admin-password" className="mb-2 block text-xs uppercase tracking-[0.15em] text-white/60">Password</label>
                    <input
                        id="admin-password"
                        data-testid="admin-login-password"
                        type="password"
                        required
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className={inputCls}
                    />
                </div>
            </div>
            {error && (
                <p data-testid="admin-login-error" className="mt-4 border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-300">
                    {error}
                </p>
            )}
            <button
                type="submit"
                data-testid="admin-login-submit"
                disabled={loading}
                className="mt-7 flex w-full items-center justify-center gap-3 bg-tl-orange px-8 py-4 font-mono-tl text-sm font-semibold uppercase tracking-[0.15em] text-tl-dark transition-colors duration-300 hover:bg-tl-orangeHover disabled:opacity-60"
            >
                {loading ? <Loader2 size={16} className="animate-spin" /> : "Entra"}
            </button>
        </form>
    );
};
